import { EmployeeInput, ProcessEmployeeIdCardInput } from '@vivaldis/graphql'
import { FC } from 'react'
import { StepProvider } from './provider/StepProvider'
import { AddWorkPermitStep } from './steps/AddWorkPermitStep'
import { ConfirmEditingStep } from './steps/ConfirmEditingStep'
import { EditManuallyStep } from './steps/EditManuallyStep'
import { OcrFailedStep } from './steps/OcrFailedStep'
import { OcrSucceededStep } from './steps/OcrSucceededStep'
import { UploadIdCardStep } from './steps/UploadIdCardStep'
import { CountryType } from './types/CountryType'
import { Employee } from './types/Employee'

interface Props {
  employee: Employee
  onEmployeeUpdate: (employeeInput: EmployeeInput) => Promise<void>
  onIDCardSubmit: (
    processEmployeeIdCardInput: ProcessEmployeeIdCardInput
  ) => Promise<Employee | undefined>
  onGoBack: () => void
  countries: CountryType[]
}

export const EditEmployeePersonalInformationForm: FC<Props> = ({
  employee,
  onEmployeeUpdate,
  onGoBack,
  onIDCardSubmit,
  countries
}) => {
  return (
    <StepProvider>
      <ConfirmEditingStep onCancel={onGoBack} />
      <UploadIdCardStep employee={employee} onIDCardSubmit={onIDCardSubmit} />
      <OcrFailedStep />
      <OcrSucceededStep
        countries={countries}
        employee={employee}
        onGoBack={onGoBack}
      />
      <EditManuallyStep
        countries={countries}
        employee={employee}
        onSubmit={onEmployeeUpdate}
        onGoBack={onGoBack}
      />
      <AddWorkPermitStep onEmployeeUpdate={onEmployeeUpdate} />
    </StepProvider>
  )
}
